import { useMutation } from "@tanstack/react-query";
import { updateProject } from "../../../api/projects/updateProject";

export const useUpdateProject = () => {

  return useMutation({
    mutationKey: ["updateProject"],
    mutationFn: updateProject
  })
}